const getCroppedImg = (image, crop, finalWidth = false, finalHeight = false) => {
  const scaleX = image.naturalWidth / image.width
  const scaleY = image.naturalHeight / image.height

  const bestWidth = Math.min(finalWidth || Infinity, crop.width * scaleX)
  const bestHeight = Math.min(finalHeight || Infinity, crop.height * scaleY)

  const canvas = document.createElement('canvas')
  canvas.width = bestWidth
  canvas.height = bestHeight
  const ctx = canvas.getContext('2d')

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    bestWidth,
    bestHeight
  )

  return new Promise((resolve, _) => {
    canvas.toBlob(resolve,'image/png')
  })
}

export { getCroppedImg }